import { Injectable, ErrorHandler, Injector } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorService } from './error.service';
//import { AlertService } from './alert.service';
import { MicrosoftApplicationInsightsService } from './microsoft-application-insights.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  private _microsoftApplicationInsightsService: MicrosoftApplicationInsightsService
  private _errorService: ErrorService
  //private _alertService: AlertService
  constructor(private injector: Injector) {
    this._microsoftApplicationInsightsService = this.injector.get(MicrosoftApplicationInsightsService);
    this._errorService = this.injector.get(ErrorService);
    //this._alertService = this.injector.get(AlertService);
  }

  handleError(error: Error | HttpErrorResponse) {
    let message;
    let stackTrace;
    /* if (error instanceof HttpErrorResponse) {
      // Servidor errores
      message = this._errorService.getServerMessage(error);
      stackTrace = this._errorService.getServerStack(error);
   //   this._alertService.showError(message);
    } else { */
      // Cliente errores
      message = this._errorService.getClientMessage(error);
      stackTrace = this._errorService.getClientStack(error);
    //  this._alertService.showError(message);
   // }

    // Registrar el error en aplication insigths
    this._microsoftApplicationInsightsService.logError(error, window.location.href, stackTrace);
  }
}
